var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("span", [_vm._v("区域占位总览")]),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "15px" },
                  attrs: { icon: "el-icon-refresh", size: "mini" },
                  on: { click: _vm.loadData }
                },
                [_vm._v("刷新")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-plus",
                    size: "mini"
                  },
                  on: { click: _vm.showAddDialog }
                },
                [_vm._v("添加区域")]
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "20px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-card stat-total" }, [
                  _c("div", { staticClass: "stat-num" }, [
                    _vm._v(_vm._s(_vm.totalCount))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("总区域数")])
                ])
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-card stat-occupied" }, [
                  _c("div", { staticClass: "stat-num" }, [
                    _vm._v(_vm._s(_vm.occupiedCount))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("已占区域")])
                ])
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-card stat-free" }, [
                  _c("div", { staticClass: "stat-num" }, [
                    _vm._v(_vm._s(_vm.freeCount))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("空闲区域")])
                ])
              ]),
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat-card stat-rate" }, [
                  _c("div", { staticClass: "stat-num" }, [
                    _vm._v(_vm._s(_vm.occupyRate) + "%")
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("占用率")])
                ])
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "全部状态", clearable: "" },
                      on: { change: _vm.onFilterChange },
                      model: {
                        value: _vm.filterStatus,
                        callback: function($$v) {
                          _vm.filterStatus = $$v
                        },
                        expression: "filterStatus"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "全部", value: "" } }),
                      _c("el-option", {
                        attrs: { label: "已占用", value: "occupied" }
                      }),
                      _c("el-option", {
                        attrs: { label: "空闲", value: "free" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        placeholder: "搜索区域名称 / 会员编号",
                        clearable: ""
                      },
                      on: { clear: _vm.onFilterChange },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.onFilterChange($event)
                        }
                      },
                      model: {
                        value: _vm.filterKeyword,
                        callback: function($$v) {
                          _vm.filterKeyword = $$v
                        },
                        expression: "filterKeyword"
                      }
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.onFilterChange },
                        slot: "append"
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ]
            },
            [
              _vm._l(_vm.filteredProvinces, function(province) {
                return _c(
                  "div",
                  { key: province.id, staticClass: "province-block" },
                  [
                    _c(
                      "div",
                      { staticClass: "province-header" },
                      [
                        _c("span", { staticClass: "province-name" }, [
                          _vm._v(_vm._s(province.name))
                        ]),
                        _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { size: "mini", type: "info" }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(province.cities.length) + " 个市 "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._l(province.cities, function(city) {
                      return _c(
                        "div",
                        { key: city.id, staticClass: "city-block" },
                        [
                          _c("div", { staticClass: "city-header" }, [
                            _c("span", { staticClass: "city-name" }, [
                              _vm._v(_vm._s(city.name))
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "district-grid" },
                            _vm._l(city.districts, function(district) {
                              return _c(
                                "div",
                                {
                                  key: district.id,
                                  staticClass: "district-card",
                                  class: district.occupied
                                    ? "district-occupied"
                                    : "district-free",
                                  on: {
                                    click: function($event) {
                                      return _vm.onDistrictClick(district)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "district-name" }, [
                                    _vm._v(_vm._s(district.name) + " "),
                                    _c(
                                      "span",
                                      { staticClass: "district-code" },
                                      [
                                        _vm._v(
                                          "[" + _vm._s(district.code) + "]"
                                        )
                                      ]
                                    )
                                  ]),
                                  district.occupied
                                    ? _c(
                                        "div",
                                        { staticClass: "district-agent" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-user"
                                          }),
                                          _c("span", [
                                            _vm._v(_vm._s(district.agentNumber))
                                          ])
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "district-agent" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "free-text" },
                                            [_vm._v("空闲")]
                                          )
                                        ]
                                      )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              }),
              _vm.filteredProvinces.length === 0 && !_vm.loading
                ? _c("el-empty", { attrs: { description: "暂无数据" } })
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editDialog.occupied ? "编辑区域代理" : "添加区域代理",
            visible: _vm.editDialog.visible,
            width: "500px",
            "append-to-body": true,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px 20px" } },
            [
              _c("div", { staticClass: "edit-region-info" }, [
                _c("span", { staticClass: "edit-region-label" }, [
                  _vm._v("区域：")
                ]),
                _c("span", { staticClass: "edit-region-value" }, [
                  _vm._v(
                    _vm._s(_vm.editDialog.provinceName) +
                      " / " +
                      _vm._s(_vm.editDialog.cityName) +
                      " / " +
                      _vm._s(_vm.editDialog.districtName) +
                      " [" +
                      _vm._s(_vm.editDialog.districtCode) +
                      "]"
                  )
                ])
              ]),
              _c(
                "el-form",
                {
                  ref: "editForm",
                  staticStyle: { "margin-top": "20px" },
                  attrs: {
                    model: _vm.editDialog,
                    rules: _vm.editRules,
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "会员编号", prop: "number" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入会员编号" },
                        model: {
                          value: _vm.editDialog.number,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog, "number", $$v)
                          },
                          expression: "editDialog.number"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm.editDialog.occupied
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        loading: _vm.editDialog.delLoading
                      },
                      on: { click: _vm.onRemoveAgent }
                    },
                    [_vm._v("移除代理")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.editDialog.submitLoading
                  },
                  on: { click: _vm.onSubmitAgent }
                },
                [_vm._v(_vm._s(_vm.editDialog.occupied ? "修 改" : "添 加"))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加区域",
            visible: _vm.addDialog.visible,
            width: "500px",
            "append-to-body": true,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.addDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px 20px" } },
            [
              _c(
                "el-form",
                {
                  ref: "addForm",
                  attrs: {
                    model: _vm.addDialog,
                    rules: _vm.addRules,
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "上级区域" } },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          options: _vm.areaTree,
                          props: _vm.addCascaderProps,
                          clearable: true,
                          filterable: true,
                          placeholder: "不选择则为新增省份"
                        },
                        on: { change: _vm.onAddParentChange },
                        model: {
                          value: _vm.addDialog.parent,
                          callback: function($$v) {
                            _vm.$set(_vm.addDialog, "parent", $$v)
                          },
                          expression: "addDialog.parent"
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#909399",
                            "margin-top": "5px"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.addLevelTip) + " ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "区域名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入区域名称" },
                        model: {
                          value: _vm.addDialog.name,
                          callback: function($$v) {
                            _vm.$set(_vm.addDialog, "name", $$v)
                          },
                          expression: "addDialog.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "区域编码", prop: "code" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "自动生成，可修改" },
                        model: {
                          value: _vm.addDialog.code,
                          callback: function($$v) {
                            _vm.$set(_vm.addDialog, "code", $$v)
                          },
                          expression: "addDialog.code"
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "12px",
                            color: "#909399",
                            "margin-top": "5px"
                          }
                        },
                        [_vm._v(" 已按同级最大编码自动 +1，可手动修改 ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.addDialog.visible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.addDialog.loading },
                  on: { click: _vm.onSubmitAdd }
                },
                [_vm._v("添 加")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }